// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 课程系列详情 GET /course/series/getCourseSeriesInfo */
export async function courseSeriesGetCourseSeriesInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.courseSeriesGetCourseSeriesInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultCourseSeriesInfoResp>('/course/series/getCourseSeriesInfo', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
